import { useState, useEffect } from 'react';
import { Language } from '../types';

// Function to detect browser language
const detectBrowserLanguage = (): Language => {
  if (typeof window === 'undefined') return 'en';
  
  const browserLang = navigator.language || (navigator as any).userLanguage;
  
  // Check if browser language starts with 'tr' (Turkish)
  if (browserLang.startsWith('tr')) {
    return 'tr';
  }
  
  // Check if browser language starts with 'en' (English)
  if (browserLang.startsWith('en')) {
    return 'en';
  }
  
  // For other languages, default to English
  return 'en';
};

export const useLanguage = () => {
  const [language, setLanguage] = useState<Language>(() => {
    // First check if user has previously saved a language preference
    const savedLanguage = localStorage.getItem('portfolio-language');
    if (savedLanguage) {
      return savedLanguage as Language;
    }
    
    // If no saved preference, detect browser language
    return detectBrowserLanguage();
  });

  useEffect(() => {
    localStorage.setItem('portfolio-language', language);
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(prevLanguage => prevLanguage === 'en' ? 'tr' : 'en');
  };

  return { language, setLanguage, toggleLanguage };
};
